import React, {
    useState,
    useEffect,
    useCallback,
} from 'react'
import PropTypes from 'prop-types'
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import classNames from 'classnames'
import axios from 'axios'
import { v4 as uuid } from 'uuid'
import NumberFormat from 'react-number-format';
import SimpleBar from 'simplebar-react'
import Parser from 'html-react-parser';
import 'simplebar/dist/simplebar.min.css'

// import { useHistory } from "react-router-dom";

// hooks
import useWindowSize from '../../../../Hooks/useWindowSize'
// import useRouter from 'Hooks/useRouter'
// import useLockBodyScroll from 'Hooks/useLockBodyScroll'
// import useScrollTop from 'Hooks/useScrollTop'

// Atoms
import Button, { ButtonCategory } from './../../../Atoms/Button'
// import Dropdown from './../../../Atoms/Dropdown'
// import SearchField from './../../../Atoms/SearchField'
import Title, { TitleTag, TitleStyle } from './../../../Atoms/Title';
import InputSelect, { InputSelectType } from './../../../Atoms/InputSelect';

// Mol
// import PlayPlanCardMol from './../../../Molecules/Cards/Plan/Play'
import General2PlanCardMol from './../../../Molecules/Cards/Plan/General2'
// import BreadcrumbMol from 'Components/Molecules/Breadcrumb'
import RangeSlider from './../../../Molecules/RangeSlider'
import PaginationMol from './../../../Molecules/Pagination'

// Sass
import '../../../../Sass/includes/Components/modules/C23.sass'

import C25PeopleOrg from '../C25v2'

const queryParams = new URLSearchParams(window.location.search);

const ServiceFilter = React.memo((props) => {
    const {
        onSubmit,
        showFilter,
        setShowFilter,
        // optionsOrder,
        // dataRegiones,
        // optionsRegiones,
        dataFilterTypes,
        dataFilterTypesChilds,
        dataFilterTypesHead,
        // rangePrice,
        handleChangeFilterPrice,
        // getPlanesByComuna,
        //getPlanesByCheckBox,
        getPlanesByCheckBoxChilds,
        getPlanesByCheckBoxHead,
        // keysTypeCompare,
        counterFilters,
        clearFilters,
        showRangPrice,
    } = props

    // const router = useRouter()
    const {
        width: widthWindow,
    } = useWindowSize()

    const [rangePrice] = useState(props.rangePrice)
    // console.log("ServiceFilter rangePrice ", rangePrice)

    // const [dataComunas, setDataComunas] = useState([])

    const schemaFilter = yup.object().shape({
        // rangeMin: 
        //     yup.number()
        //         .typeError('El rango minimo solo puede contener números')
        //         .min(10, 'El rango minimo debe ser igual o mayor que 10'),
        // rangeMax: 
        //     yup.number()
        //         .typeError('El rango maximo solo puede contener números')
        //         // .matches(/[0-9]+/gi, "Enter number only")
        //         // .length(3, 'Mas de 3'),
    });

    // const {
    //     paymentType: paymentTypeQuery , 
    //     paymentMethod : paymentMethodQuery,
    //     option: optionQuery,
    // } = router.query

    // console.log('query: ', router.query)

    const {
        register,
        handleSubmit,
        // watch, 
        // errors, 
        // getValues,  
        // control,
        setValue,
        //formState, 
        unregister
    } = useForm({
        defaultValues: {
            minPrice: '',
            maxPrice: '',
            // typePlan: [],
            region: null,
            zone: null,
        },
        resolver: yupResolver(schemaFilter),
    });
    // 
    // const WatchAllFields = watch()
    // console.log(WatchAllFields)
    // useEffect(()=>{
    //     console.log('Valores cambiando de los filtros', WatchAllFields);
    // },[WatchAllFields]) 

    useEffect(() => {
        register("minPrice"); // custom register minPrice input
        register("maxPrice"); // custom register maxprice input
        return () => {
            unregister("minPrice"); // custom register minPrice input
            unregister("maxPrice");
        }
    }, [register, unregister])

    const handleChangePrice = useCallback((valores) => {
        setValue('minPrice', valores.minPrice)
        setValue('maxPrice', valores.maxPrice)
        handleChangeFilterPrice(valores)
    }, [setValue, handleChangeFilterPrice])

    const classMain = classNames(
        'c23FilterMain',
        { 'c23FilterMainHide': !showFilter },
    )

    useEffect(() => {
        if (widthWindow > 960) {
            setShowFilter(true)

        } else if (widthWindow <= 960) {
            setShowFilter(false)
        }
    }, [widthWindow, setShowFilter])

    // async function getComuna(selected) {
    //     // console.log("dataComuna********************************", selected.target.value, selected.value)
    //     let url_servicio_web = localStorage.getItem('url_servicio_web')
    //     const configGetComuna = {
    //         method: 'POST',
    //         url: url_servicio_web + "get_Comuna?fi_Region=" + selected.target.value,

    //     };
    //     let response = await axios(configGetComuna)
    //     let Comunas = []
    //     console.log("response- configGetComuna------------------------->", response);
    //     response.data.forEach(element => {
    //         Comunas.push({ value: element.fi_COMUNA, label: element.fc_DESCRIPCION, fc_TIPO_DISPONIBILIDAD: element.fc_TIPO_DISPONIBILIDAD })
    //     });
    //     setDataComunas(Comunas)
    // }
    // let id_familia = localStorage.getItem('id_familia')
    
    const InputCheckSelectDataNew = (dataNew) => {
        return dataNew?.lstHijos?.map((item) => (
            <>
                <InputSelect
                    key={uuid()}
                    // type={id_familia !== "SHO" && id_familia !== undefined ? InputSelectType.RADIO : InputSelectType.CHECKBOX}
                    type={InputSelectType.CHECKBOX}
                    text={item.fc_DESCRIPCION}
                    name={item.fi_OPCION_FILTRO}
                    className='c23FilterCheckbox'
                    onChange={e => { getPlanesByCheckBoxChilds(e, item) }}
                    checked={item.checked}
                // disabled={item.disabled}
                // classRadio={item.lstTipoFiltro}
                />
                {
                    item.lstHijos && item.checked ?
                        item.lstHijos.map((subitem, subIndex) => (
                            <InputSelect
                                key={uuid()}
                                type={InputSelectType.CHECKBOX}
                                text={subitem.fc_DESCRIPCION}
                                name={subitem.fi_OPCION_FILTRO}
                                className='c23FilterCheckbox c23FilterCheckboxLvl2'
                                onChange={e => { getPlanesByCheckBoxChilds(e, subitem) }}
                                checked={subitem.checked}
                            />
                        )) : null
                }
            </>
        ));
    } 
    
    const InputCheckSelectData = dataFilterTypesHead
    .find(h => h.checked)?.lstHijos?.filter(lh => lh.fi_TIPO_FILTRO !== 2)?.map((item, index) => (
        <>
            <InputSelect
                key={uuid()}
                // type={id_familia !== "SHO" && id_familia !== undefined ? InputSelectType.RADIO : InputSelectType.CHECKBOX}
                type={InputSelectType.CHECKBOX}
                text={item.fc_DESCRIPCION}
                name={item.fi_OPCION_FILTRO}
                className='c23FilterCheckbox'
                onChange={e => { getPlanesByCheckBoxChilds(e, item) }}
                checked={item.checked}
            // disabled={item.disabled}
            // classRadio={item.lstTipoFiltro}
            />
            {
                item.lstHijos && item.checked ?
                    item.lstHijos.map((subitem, subIndex) => (
                        <InputSelect
                            key={uuid()}
                            type={InputSelectType.CHECKBOX}
                            text={subitem.fc_DESCRIPCION}
                            name={subitem.fi_OPCION_FILTRO}
                            className='c23FilterCheckbox c23FilterCheckboxLvl2'
                            onChange={e => { getPlanesByCheckBoxChilds(e, subitem) }}
                            checked={subitem.checked}
                        />
                    )) : null
            }
        </>
    ));
    const dataFilterTypesAdd = [];//{fi_FILTRO:1,lstHijos:[]}

    dataFilterTypesHead
    .find(h => h.checked)?.lstHijos?.filter(lh => lh.fi_TIPO_FILTRO === 2)?.forEach((item) => {

            if(dataFilterTypesAdd.find(df => df.fi_FILTRO === item.fi_FILTRO)){
                const filterAdd = dataFilterTypesAdd.find(df => df.fi_FILTRO === item.fi_FILTRO );
                filterAdd.lstHijos.push(item);
             } else {
                 const filterAdd = {fi_FILTRO:item.fi_FILTRO, fc_NOMBRE: item.fc_NOMBRE ,lstHijos:[]};
                 filterAdd.lstHijos.push(item);
                 dataFilterTypesAdd.push(filterAdd);
             }
        
    });

   
    let firstData = dataFilterTypes; //.filter((task) => familia === 'SHO' ? task.Type === tipoFilGe : task.fi_FILTRO === idSele);
    
    const InputCheckSelectDataFirts = dataFilterTypes?.length > 0 ? firstData.map((item, index) => (
        <InputSelect
            key={uuid()}
            type={InputSelectType.CHECKBOX}
            text={item.Descripcion}
            name={item.id}
            className='c23FilterCheckbox'
            onChange={e => { getPlanesByCheckBoxChilds(e, item) }}
            checked={item.checked}
        />
    )) : null

    const InputCheckSelectDataChilds = dataFilterTypesChilds?.length ? dataFilterTypesChilds.map((item, index) => (
        <InputSelect
            key={uuid()}
            type={InputSelectType.CHECKBOX}
            text={item.fc_DESCRIPCION}
            name={item.fi_OPCION_FILTRO}
            className='c23FilterCheckbox'
            onChange={e => { getPlanesByCheckBoxChilds(e, item) }}
            checked={item.checked}
        // disabled={item.disabled}
        />
    )) : null

    const InputCheckSelectDataHead = dataFilterTypesHead.map((item, index) => (
        <InputSelect
            key={uuid()}
            type={InputSelectType.RADIO}
            // register={register("typePlay[0]", {required: false})} 
            text={item.Descripcion}
            name={item.id}
            className=''
            onChange={e => { getPlanesByCheckBoxHead(e, item) }}
            checked={item.checked}
            disabled={item.disabled}
        // defaultValue='1Play'
        // checked={true}
        />
    ))

    return (
        <div className={classMain}>
            <form
                className='c23Filter'
                onSubmit={handleSubmit(onSubmit)}
            >
                {/* Solo se muestra este campo en responsive */}
                <div className='c23FilterBlock c23FilterBlockTop'>
                    {/* <p>
                        Valores de todo el formulario de filtro:
                        { JSON.stringify( getValues())}
                    </p> */}
                    <Title
                        tag={TitleTag.H2}
                        style={TitleStyle.H4}
                        className=''
                    >
                        Filtrar por
                    </Title>
                    <i className='ico-x' onClick={() => { setShowFilter(!showFilter) }}></i>
                </div>
                {
                    InputCheckSelectDataHead?.length > 1
                        ?
                        <div className='c23FilterBlock'>
                            <div className={`c23FilterBlockItems c23FilterBlockItemsShow c23FilterBlockItemsPlay`}>
                                <SimpleBar
                                    style={{ maxHeight: "200px" }}
                                >
                                    <div className='c23FilterBlockPlay' style={{display:'block'}}>
                                        {
                                            InputCheckSelectDataHead
                                        }
                                    </div>

                                </SimpleBar>
                            </div>
                        </div>
                        : null
                }
                <div className='c23FilterClear'>
                    <span>{counterFilters} filtros seleccionados</span>
                    {/* <span className='c23FilterClearAct' onClick={(e) => { clearFilters(e, true); setDataComunas([]) }}>Limpiar filtros</span> */}
                    <span className='c23FilterClearAct' onClick={(e) => { clearFilters(e, true); }}>Limpiar filtros</span>

                </div>
                { InputCheckSelectDataFirts &&
                    InputCheckSelectDataFirts.length > 0
                        ?
                        <div className='c23FilterBlock'>
                            <div className='c23FilterSubtitle'>
                                <p>
                                    {firstData?.length && firstData[0].Name}
                                </p>
                            </div>
                            <div className={`c23FilterBlockItems c23FilterBlockItemsShow`} >
                                <SimpleBar
                                    style={{ maxHeight: "200px" }}
                                >
                                    {
                                        InputCheckSelectDataFirts
                                    }
                                </SimpleBar>
                            </div>
                        </div>
                        : null
                }
                { dataFilterTypesHead.filter(h => h.checked).length && InputCheckSelectData.length > 0 ?
                    <div className='c23FilterBlock'>

                        <div className='c23FilterSubtitle'>
                            <p>
                                Tipo de plan
                            </p>

                        </div>
                        <div className={`c23FilterBlockItems c23FilterBlockItemsShow`} >
                            <SimpleBar
                                style={{ maxHeight: "370px" }}
                            >
                                {
                                    InputCheckSelectData
                                }
                            </SimpleBar>
                            {/* <InputSelect
                                type={InputSelectType.CHECKBOX}
                                register={register("typePlan[0]", { required: false })}
                                text='2 Play: Internet + Televisión'
                                name='typePlan[0]'
                                defaultValue='2 Play: Internet + Televisión'
                                className='c23FilterCheckbox'
                            /> */}

                        </div>

                    </div>
                    : null
                }
                { dataFilterTypesAdd.map((item) => (
                    <div className='c23FilterBlock' key={uuid()}>

                        <div className='c23FilterSubtitle'>
                            <p>
                                {item.fc_NOMBRE}
                            </p>

                        </div>
                        <div className={`c23FilterBlockItems c23FilterBlockItemsShow`} >
                            <SimpleBar
                                style={{ maxHeight: "370px" }}
                            >
                                {
                                    InputCheckSelectDataNew(item)
                                }
                            </SimpleBar>
                            {/* <InputSelect
                                type={InputSelectType.CHECKBOX}
                                register={register("typePlan[0]", { required: false })}
                                text='2 Play: Internet + Televisión'
                                name='typePlan[0]'
                                defaultValue='2 Play: Internet + Televisión'
                                className='c23FilterCheckbox'
                            /> */}

                        </div>

                    </div>
                    ))
                }
                {
                    InputCheckSelectDataChilds
                        ?
                        <div className='c23FilterBlock'>

                            <div className='c23FilterSubtitle'>
                                <p>
                                    Opciones
                                </p>
                            </div>
                            <div className={`c23FilterBlockItems c23FilterBlockItemsShow`} >
                                <SimpleBar
                                    style={{ maxHeight: "200px" }}
                                >
                                    {
                                        InputCheckSelectDataChilds
                                    }
                                </SimpleBar>
                            </div>
                        </div>
                        :
                        null
                }
                {
                showRangPrice &&
                    <div className='c23FilterBlock c23FilterBlockBottom'>
                        <div className="c23FilterSubtitle">
                            <p>
                                Precio
                            </p>
                        </div>

                        <div className='c23FilterRangeBar'>
                            {/* <ProgressBar percentage={60}/> */}
                            <RangeSlider
                                min={rangePrice.min}
                                max={rangePrice.max}
                                onChange={v => handleChangePrice(v)}
                            />
                        </div>

                    </div>
                }
                {/* <div className='c23FilterBlock c23FilterBlockBottom'>
                    <div className="c23FilterSubtitle">
                        <p>Ubicación</p>
                    </div>

                    <div className={`c23FilterBlockItems c23FilterBlockItemsShow`} >
                        <div className="c23FilterSelect">
                            <span> Región </span>
                            <span className="select">
                                <select defaultValue='' onChange={(selected) => getComuna(selected)}>
                                    <option value="" disabled>Selecciona una región</option>
                                    {optionsRegiones}
                                </select>
                            </span>
                        </div>
                        <div className="c23FilterSelect">
                            <span> Zona </span>
                            <span className="select">
                                <select defaultValue='-1' onChange={(selected) => getPlanesByComuna(selected)}>
                                    <option value="-1" disabled>Selecciona una zona</option>
                                    {dataComunas.map(item => (
                                        <option key={item.value} value={item.value + "_" + item.fc_TIPO_DISPONIBILIDAD}>{item.label}</option>
                                    ))}

                                </select>
                            </span>
                        </div>
                    </div>
                </div> */}

            </form>
        </div>
    )
})

ServiceFilter.propTypes = {
    onSubmit: PropTypes.func,
    showFilter: PropTypes.bool,
    setShowFilter: PropTypes.func,
}
ServiceFilter.defaultProps = {
    onSubmit: () => { },
    showFilter: true,
    setShowFilter: () => { }
}


function C23PersonasOrg(props) {
    const {
        dataChannelsBk,
        dataCategoriasBk,
    } =props
    // let history = useHistory();
    const [dataCPlanes, setdataCPlanes] = useState([])
    const [dataCPlanesBk, setdataCPlanesBk] = useState([])
    const [dataCPlanesBkHead, setdataCPlanesBkHead] = useState([])
    const [dataRegiones, setDataRegiones] = useState([])
    const [dataFilterTypes, setDataFilterTypes] = useState([])
    const [dataFilterTypesChilds, setDataFilterTypesChilds] = useState([])
    const [dataFilterTypesBK, setDataFilterTypesBk] = useState([])
    const [dataFilterTypesHead, setDataFilterTypesHead] = useState([])
    const [dataFilterOptions, setDataFilterOptions] = useState([])
    const [inputSearch, setinputSearch] = useState('')
    const [optionFilter, setOptionFilter] = useState('')
    const [optiondHigherLower, setOptiondHigherLower] = useState('')
    const [filterComuna, setFilterComuna] = useState('')
    const [rangePriceState, setRangePriceState] = useState({})
    const [showFilter, setShowFilter] = useState(true)
    const [offset, setOffset] = useState(0)
    const [pageCount, setPageCount] = useState(1)
    const [perPage, setPerPage] = useState(6)
    const [dataToItems, setDataToItems] = useState([])
    const [counterFilters, setCounterFilters] = useState(0)
    const [counterFiltersHead, setCounterFiltersHead] = useState(0)
    const [preFilterRemove, setPreFilterRemove] = useState(true)
    const [filterServicesOptions] = useState([])


    const [keysPlanCompare, setKeysPlanCompare] = useState([])
    const [regresaPlanes, setRegresaPlanes] = useState(false)
    const [showRangPrice, setShowRangPrice] = useState(true)

    async function getMinMaxPrice(dataArray = null) {
        // console.log("Calculate range price min and max***********", dataArray)
        if (!dataArray?.length) {
            console.log("Calculate range price min and max if ***********", dataArray)
            // return { min: 0, max: 20000 }
            await setRangePriceState({ min: 0, max: 20000 })
        } else {
            // console.log("Calculate range price min and max else***********", dataArray)
            dataArray.sort(function (a, b) {
                return a.fi_PRECIO_PLAN - b.fi_PRECIO_PLAN
            })
            let min = dataArray[0].fi_PRECIO_PLAN;
            let max = dataArray[dataArray.length - 1].fi_PRECIO_PLAN;
            console.log("Calculate range price min and max___________________________________", min, max)
            if(max <= 0){
                setShowRangPrice(false)
            }
            await setRangePriceState({ min: min, max: max > 0 ? max : 100 })
        }
    }

    async function getCPlanes() {
        console.log("get_cplanes_byserviciocategoria********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        let fi_categoria = localStorage.getItem('fi_categoria') ? localStorage.getItem('fi_categoria') : '';
        let fi_servicio = localStorage.getItem('fi_servicio') ? localStorage.getItem('fi_servicio') : '';
        let fc_tipo_plan = localStorage.getItem('fc_tipo_plan') ? localStorage.getItem('fc_tipo_plan') : '';
        const configCPlanes = {
            method: 'GET',
            url: `${url_servicio_web}get_cplanes_byserviciocategoria?fi_categoria=${fi_categoria}&fi_servicio=${fi_servicio}&fc_tipo_plan=${fc_tipo_plan}`,
            data: {},
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },
        };
        let response = await axios(configCPlanes)
        console.log("response- getCPlanes------------------------->", response);
        let pageCountVal = response.data ? (Math.ceil(response.data.length / perPage)) : 1;
        await setdataCPlanes(response.data)
        await setdataCPlanesBk(response.data)
        await setdataCPlanesBkHead(response.data)
        getMinMaxPrice(response.data)

        setPageCount(pageCountVal)
        setPerPage(6)
        let version_comparador = localStorage.getItem('version_comparador')
        if(version_comparador === "v2"){
            setPerPage(8)
        }else{
            setPerPage(6)
        }
    }

    async function getRegiones() {
        // console.log("getRegiones********************************+")
        // let url_servicio_web = localStorage.getItem('url_servicio_web')
        // const configRegiones = {
        //     method: 'GET',
        //     url: url_servicio_web + "get_Region",

        // };
        // let response = await axios(configRegiones)
        let Regiones = []
        // console.log("response- getRegiones------------------------->", response);
        // response.data.forEach(element => {
        //     Regiones.push({ value: element.fi_REGION, label: element.fc_DESCRIPCION })
        // });
        setDataRegiones(Regiones)
    }

    async function getFilterTypes() {
        // console.log("getFilterTypes********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        let id_filtro_planes = parseInt(localStorage.getItem('id_filtro_planes'))
        let fc_familia = localStorage.getItem('id_familia')
        const configFilterTypes = {
            method: 'GET',
            url: url_servicio_web + "get_FilterTypes?fc_familia=" + fc_familia+"&fi_tipo_filtro=2",
        };
        let response = await axios(configFilterTypes)
        let FilterTypes = [] //, elements = {}
        console.log("response- getFilterTypes------------------------->", response);

        response.data.forEach(dfilt => {
            FilterTypes.push({ 
                id: dfilt.fi_OPCION_FILTRO, 
                fi_FILTRO: dfilt?.fi_FILTRO, 
                Descripcion: dfilt.fc_DESCRIPCION, 
                checked: false, 
                Name: dfilt.fc_NOMBRE, 
                disabled: false,
                lstHijos:dfilt.lstHijos 
            })
        });
        FilterTypes = FilterTypes.filter((item) => item.fi_FILTRO === id_filtro_planes)
        console.log("setDataFilterTypes:", id_filtro_planes , FilterTypes)
        setDataFilterTypes(FilterTypes)
        setDataFilterTypesBk(FilterTypes)
    }

    // async function getFilterTypesHead() {
    //     // console.log("getFilterTypes********************************+")
    //     let url_servicio_web = localStorage.getItem('url_servicio_web')
    //     let fc_familia = localStorage.getItem('id_familia')
    //     const configRegiones = {
    //         method: 'GET',
    //         url: url_servicio_web + "get_HeadFilterTypes?fc_familia=" + fc_familia,
    //     };
    //     let response = await axios(configRegiones)
    //     let FilterTypesHead = [], FilterServicesOptions = [] //, elements = {}
    //     console.log("response- getFilterTypesHead------------------------->", response);

    //     response.data.forEach(dfilt => {
    //         FilterTypesHead.push({ 
    //             id: dfilt.fi_OPCION_FILTRO, 
    //             Descripcion: dfilt.fc_DESCRIPCION, 
    //             checked: false, 
    //             disabled: false,
    //             lstHijos: dfilt.lstHijos
    //          })
    //     });
    //     FilterTypesHead.map((filt, index) => (
    //         filt.lstHijos?.forEach(h => {
    //             if(h.fi_TIPO_FILTRO === 2){
    //                 let f = FilterServicesOptions.filter((item) => item.fc_DESCRIPCION === h.fc_DESCRIPCION) 
    //                 console.log("FilterServicesOptions:", f)
    //                 if(f.length){
    //                     let newFilter = FilterServicesOptions.filter((item, index)=>{
    //                         if(item.fc_DESCRIPCION === h.fc_DESCRIPCION){
    //                             let newIds = item.IdsFilters
    //                             newIds.push(h.fi_OPCION_FILTRO)
    //                             item.IdsFilters = newIds
    //                         }
    //                         return item
    //                     })
    //                     FilterServicesOptions = newFilter;
    //                     // FilterServicesOptions.push({fc_DESCRIPCION: h.fc_DESCRIPCION, IdsFilters:[h.fi_OPCION_FILTRO]})
    //                 }else{
    //                     FilterServicesOptions.push({fc_DESCRIPCION: h.fc_DESCRIPCION, IdsFilters:[h.fi_OPCION_FILTRO]})
    //                 }
    //             }
    //         })
    //     ))
    //     console.log("setDataFilterTypes", FilterTypesHead, "options", FilterServicesOptions)
    //     setDataFilterTypesHead(FilterTypesHead)
    //     setFilterServicesOptions(FilterServicesOptions)
    // }

    async function getFilterOptions() {
        // console.log("getFilterOptions********************************+")
        // let url_servicio_web = localStorage.getItem('url_servicio_web')
        // let fc_familia = localStorage.getItem('id_familia')
        // const configRegiones = {
        //     method: 'GET',
        //     url: url_servicio_web + "get_FilterOptions?fc_familia=" + fc_familia,

        // };
        // let response = await axios(configRegiones)
        let FilterOptions = [] //, elements = {}
        // console.log("response- getFilterOptions------------------------->", response);

        // response.data.forEach(dfilt => {
        //     FilterOptions.push({ value: dfilt.fi_OPCION_FILTRO, label: dfilt.fc_DESCRIPCION })
        // });
        setDataFilterOptions(FilterOptions)
        console.log("setDataFilterOptions", dataFilterOptions)
    }

    const handleChangeFilterPrice = (el) => {
        const result = Object.values(el);
        console.log("handleChangeFilterPrice.......", result);
        // setRangePriceState({ min: result[0], max: result[1] })
        getFilterPlansByPrices(result[0], result[1])

    }
    const getPlanesByCheckBoxChilds = (el, item) => {
        let isCheck = el.target.checked
        let idFiltro = parseInt(el.target.name)
        item.checked = isCheck
        let newArrayChecks = dataFilterTypes.map((filt, index) => {
            
            return filt;
        })
        setDataFilterTypes(newArrayChecks)
        console.log("getPlanesByCheckBoxChilds to checkkkkkkkkkk: ", el.target.type, newArrayChecks)
        console.log("getPlanesByCheckBoxChilds isCheck: from lstFiltrosxPlan ", isCheck, "idFiltro: " + idFiltro, item, dataFilterTypesHead, newArrayChecks);
        getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, optionFilter, inputSearch)
    }

    const getPlanesByCheckBox = (el, item) => {
        let isCheck = el.target.checked
        let idFiltro = parseInt(el.target.name)
        let lstFiltrosxPlan = item.lstTipoFiltro
        let id_familia = localStorage.getItem("id_familia")
        console.log("getPlanesByCheckBox----------------------------- id_familia:", id_familia, " lstTipoFiltro:", item.lstTipoFiltro)

        let newArrayChecks = dataFilterTypes.map((filt, index) => {
            if (lstFiltrosxPlan?.length && isCheck) {
                filt.disabled = true
            } else {
                filt.disabled = false
            }
            if (filt.id === item.id) {
                filt.checked = isCheck
                filt.disabled = false
            }
            return filt;
        })

        if (lstFiltrosxPlan?.length && isCheck) {
            newArrayChecks = dataFilterTypes.map((filt, index) => {
                if (filt.id === item.id) {
                    filt.checked = isCheck
                    filt.disabled = false
                } else {
                    filt.checked = false
                    filt.disabled = true
                }
                return filt;
            })
            setDataFilterTypesChilds(lstFiltrosxPlan)
        } else {

            let newArrayChecksChilds = dataFilterTypesChilds.map((filt, index) => {
                filt.checked = false
                return filt;
            })

            setDataFilterTypesChilds(newArrayChecksChilds)
            if (isCheck) {
                // if (id_familia !== "SHO") {
                //     newArrayChecks = dataFilterTypes.map((filt, index) => {
                //         if (filt.id === item.id) {
                //             filt.checked = isCheck
                //             filt.disabled = false
                //         } else {
                //             filt.checked = false
                //             filt.disabled = true
                //         }
                //         return filt;
                //     })
                // }
                setDataFilterTypes(newArrayChecks)
                console.log("getPlanesByCheckBox isCheck: ", isCheck, "idFiltro: " + idFiltro, item, dataFilterTypes, newArrayChecks, "lstFiltrosxPlan", lstFiltrosxPlan?.length, lstFiltrosxPlan);
                getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, optionFilter, inputSearch)
            }
            setDataFilterTypesChilds([])
        }
        // setDataFilterTypes(newArrayChecks)
        // console.log("getPlanesByCheckBox isCheck: ", isCheck, "idFiltro: " + idFiltro, item, dataFilterTypes, newArrayChecks, "lstFiltrosxPlan", lstFiltrosxPlan?.length, lstFiltrosxPlan);
        // getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, optionFilter, inputSearch)
    }

    const getPlanesByCheckBoxHead = (el, item) => {
        let isCheck = el.target.checked
        let idFiltro = parseInt(el.target.name)

        let newArrayChecks = dataFilterTypesHead.map((filt, index) => {
            if (filt.id === item.id) {
                filt.checked = isCheck
            } else {
                // filt.disabled = isCheck
                filt.checked = !isCheck
                filt.lstHijos?.forEach(h => {
                    h.checked = false
                    h.lstHijos?.forEach(h2 => {
                        h2.checked = false
                    })
                })
            }
            return filt;
        })
        setDataFilterTypesHead(newArrayChecks)
        console.log("getPlanesByCheckBoxHead isCheck: ", isCheck, "idFiltro: " + idFiltro, item, dataFilterTypesHead, newArrayChecks);
        // getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, optionFilter, inputSearch)
        if (isCheck) {
            getDataFilterTypes(item.id)
        } else {
            getDataFilterTypes()
        }
    }

    const getDataFilterTypes = (idFiltro = null) => {
        let newArrayChecks = []
        if (idFiltro !== null) {
            clearFilters(null, false)
            newArrayChecks = dataFilterTypesHead.filter(filt => filt.checked);
            getFilterPlansByPlay(newArrayChecks)
            setCounterFiltersHead(1)
        } else {
            newArrayChecks = dataFilterTypesBK
            clearFilters(null, true)
            setCounterFiltersHead(0)
        }
        setDataFilterTypes(newArrayChecks)
        console.log("getDataFilterTypes isCheck: ", "idFiltro: " + idFiltro, dataFilterTypes, newArrayChecks);

    }

    const getPlanesByComuna = (el) => {
        console.log("getPlanesByComuna---------------------", el, el.target.value);
        let valComuna = el.target.value.split("_")[1]
        setFilterComuna(valComuna)
        getFilterPlansByComuna(valComuna)
    }

    // const onChangeFilterOptions = (el) => {

    //     let val = el.target.value
    //     setOptionFilter(val)
    //     getFilterPlanesByOptions(val)
    //     console.log("onChangeFilterOptions---------------------", val);
    // }

    const handleChangeCompare = (el) => {
        let isCheck = el.target.checked
        let planId = parseInt(el.target.name)
        console.log("handleChangeCompare isCheck: " + isCheck, "planId:" + planId);
        if (isCheck) {
            const exist = keysPlanCompare.filter((id) => id === planId);
            if (!exist.length) {
                setKeysPlanCompare([...keysPlanCompare, planId])
            }
        } else {
            let newarray = keysPlanCompare.filter(element => element !== planId);
            setKeysPlanCompare(newarray)
        }
    }

    const resetHandleClick = (el) => {

        console.log("resetHandleClick: " + el);
        setKeysPlanCompare([])
        setDataToItems([])
    }
    function clearFilters(e, clearHead = true) {
        console.log("clearFilters: ", e);
        setinputSearch('')
        setOptionFilter('')
        setFilterComuna('')
        // setDataFilterOptions([])
        setOptionFilter('')
        setCounterFilters(0)
        setCounterFiltersHead(0)

        setdataCPlanes(dataCPlanesBkHead)
        setdataCPlanesBk(dataCPlanesBkHead)

        let newArrayChecksChilds = dataFilterTypesChilds?.length ? dataFilterTypesChilds.map((filt, index) => {
            filt.checked = false
            return filt;
        }) : []
        setDataFilterTypesChilds(newArrayChecksChilds)
        setDataFilterTypesChilds([])
        let pageCountVal = dataCPlanesBkHead.length ? (Math.ceil(dataCPlanesBkHead.length / perPage)) : 1;
        setOffset(0)
        setPageCount(pageCountVal)
        let newArrayChecks = dataFilterTypes.map((filt, index) => {
            if (filt.id) {
                filt.checked = false
                filt.disabled = false
            }
            return filt;
        })
        setDataFilterTypes(newArrayChecks)
        if (clearHead) {
            let newArrayChecksHead = dataFilterTypesHead.map((filt, index) => {
                if (filt.id) {
                    filt.checked = false
                    filt.disabled = false
                }
                filt.lstHijos?.forEach(h => {
                    h.checked = false
                    h.lstHijos?.forEach(h2 => {
                        h2.checked = false
                    })
                })
                return filt;
            })
            setDataFilterTypesHead(newArrayChecksHead)
        }
        console.log("clearFilters: end: ", e, clearHead);
    }

    function removeItemHandleClick(el) {
        // let idPlanRemove = parseInt(el.target.id)
        console.log("removiendo", el)
        let idPlanRemove = parseInt(el.fi_PLAN)
        if (idPlanRemove) {
            let newarray = keysPlanCompare.filter(element => element !== idPlanRemove);
            // setKeysPlanCompare(newarray)
            // console.log("removeItemHandleClick: " + el.target, "id: " + el.target.id, "name: " + el.target.name, idPlanRemove, newarray);
            setKeysPlanCompare(newarray)
            let dataToItems = dataCPlanesBk.filter(f => newarray.includes(f.fi_PLAN));
            let arrayItemes = { items: dataToItems }
            console.log("dataToItems::::::::::::::::::::" + dataToItems, arrayItemes, keysPlanCompare.length);
            setDataToItems(arrayItemes)
        }
        // setDataToItems([])
    }

    function onChangeInputSearch(e) {
        console.log("onChangeInputSearch", e.target.value)
        let textValue = e.target.value
        if (textValue.length) {
            setinputSearch(textValue)

        } else {
            let list = dataCPlanesBk
            list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)
            setdataCPlanes(list)
            let pageCountVal = list.length ? (Math.ceil(list.length / perPage)) : 1;
            setOffset(0)
            setPageCount(pageCountVal)
            setinputSearch('')
        }
    }

    function getFilterPlansByPrices(min, max) {
        console.log("function getFilterPlansByPrices***********", min, max)
        let r = { min: min, max: max }
        getFilterPlansMulti(r, dataFilterTypes, filterComuna, optionFilter, inputSearch)
        // let data = dataCPlanes.length ? dataCPlanes : [];

        // let newDataFilter = data.filter((plan, index) => {
        //     // console.log("getFilterPlans... filter:", index, min, max, plan.fi_PRECIO_PLAN)
        //     // console.log("getFilterPlans... filter:", index, min + " es mayor " + mayor, max + " es menor " + menor, plan.fi_PRECIO_PLAN)
        //     return ((plan.fi_PRECIO_PLAN >= min) === true && (plan.fi_PRECIO_PLAN <= max) === true);
        // });
        // console.log("getFilterPlansByPrices....------", newDataFilter)
        // let list = newDataFilter
        // list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)

        // let pageCountVal = newDataFilter.length ? (Math.ceil(newDataFilter.length / perPage)) : 1;
        // setdataCPlanes(list)
        // // getMinMaxPrice()
        // // handlePageClick({selected: 0})
        // setPageCount(pageCountVal)
        // setOffset(0)
        // console.log("to search---------- getFilterPlansByPrices:", pageCountVal, newDataFilter, newDataFilter.length)
    }

    function getFilterPlansByComuna(fc_TIPO_DISPONIBILIDAD) {
        console.log("getFilterPlansByComuna***********", fc_TIPO_DISPONIBILIDAD)
        getFilterPlansMulti(rangePriceState, dataFilterTypes, fc_TIPO_DISPONIBILIDAD, optionFilter, inputSearch)
        // let data = dataCPlanes.length ? dataCPlanes : [];

        // let newDataFilter = data.filter((plan, index) => {
        //     return plan.fc_TIPO_DISPONIBILIDAD === fc_TIPO_DISPONIBILIDAD;
        // });
        // console.log("getFilterPlansByComuna....------", newDataFilter)
        // let list = newDataFilter
        // list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)

        // let pageCountVal = newDataFilter.length ? (Math.ceil(newDataFilter.length / perPage)) : 1;
        // setdataCPlanes(list)
        // setPageCount(pageCountVal)
        // setOffset(0)
        // console.log("---------- getFilterPlansByComuna:", pageCountVal, newDataFilter, newDataFilter.length)
    }

    // function getFilterPlanesByOptions(idOpcionFiltro) {
    //     getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, idOpcionFiltro, inputSearch)
    // }

    function getFilterPlansByPlay(dataFilterTypesData) {
        let data = dataCPlanesBkHead?.length ? dataCPlanesBkHead : []
        let newDataFilter = data.filter((data, index) => {
            let flagCheck = -1;
            let arraykeyCheck = []
            let CheckedsBox = dataFilterTypesData.map((filt, index) => {
                if (filt.id) {
                    arraykeyCheck.push(filt.id)
                }
                return filt
            })

            let isExist = false
            let result = data.lstFiltrosxPlan.map(option => {
                let isSameId = arraykeyCheck.includes(option.fi_OPCION_FILTRO)
                if (isSameId) isExist = true
                return isExist
            })
            if (isExist) {
                flagCheck = 1
            }

            // console.log("check if getFilterPlansByPlay*********** CheckedsBox: isExist", isExist, CheckedsBox, result)
            if (flagCheck > -1) {
                console.log("FLAGS-------------", flagCheck, data, arraykeyCheck, result, CheckedsBox)
                return data
            } else {
                return null
            }
        })
        let list = newDataFilter

        list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)
        console.log("to search---------- getFilterPlansByPlay:", dataCPlanesBkHead, newDataFilter, newDataFilter.length)
        let pageCountVal = newDataFilter.length ? (Math.ceil(newDataFilter.length / perPage)) : 1;
        setPageCount(pageCountVal)
        setdataCPlanes(list)
        setdataCPlanesBk(list)
        // getMinMaxPrice()
        setOffset(0)
    }
    function getFilterPlansMulti(price = null, check = null, comuna = null, option = null, input = null, OrdHigherLower = null) {
        console.log("function getFilterPlansMulti*********** Init::::", dataCPlanesBk, "price: ", price, "check: ", check, "comuna: " + comuna, "option: " + option, "input: " + input)
        // if (inputSearch.length) {
        let data = dataCPlanesBk.length ? dataCPlanesBk : [];
        let dataServOpc = []
        if (filterServicesOptions.length && dataCPlanesBkHead.length){
            dataServOpc = dataCPlanesBkHead;
        }
        let ContaFilter = [], ContaFilterHijos = []

        let newDataFilter = data.filter((data, index) => {
            let flagInput = -1, flagComuna = -1, flagOption = -1, flagCheck = -1;

            if (input.length) {
                console.log("input if getFilterPlansMulti***********", "input: " + input)
                // ContaFilter[0] = true
                for (let [key, value] of Object.entries(data)) {

                    if (key === "caracteristicas" && value.length) {
                        for (let [keyC, valueC] of Object.entries(value)) {
                            // let valueCS = String(value)

                            if (valueC.fc_TITULO.toLowerCase().search(inputSearch.toLowerCase()) > -1 || valueC.fc_VALOR.toLowerCase().search(inputSearch.toLowerCase()) > -1) {
                                console.log("------------------caracteristicas index:" + index, keyC, valueC.fc_TITULO.toLowerCase(), valueC.fc_VALOR.toLowerCase(), inputSearch.toLowerCase());
                                flagInput = index
                            }
                        }
                    } else {
                        let valueS = String(value)
                        // console.log("------------------ index:"+index, valueS.toLowerCase(), inputSearch.toLowerCase());
                        if (valueS.toLowerCase().search(inputSearch.toLowerCase()) > -1) {
                            console.log("------------------ index:" + index, key, valueS.toLowerCase());
                            flagInput = index
                        }
                    }
                }
            }
            if (comuna) {
                let dcomuna = data.fc_TIPO_DISPONIBILIDAD === comuna;
                ContaFilter[1] = true
                if (dcomuna) {
                    flagComuna = 1
                }
                console.log("comuna if getFilterPlansMulti***********", "comuna: " + comuna, flagComuna)
            }
            if (option) {
                let doption = data.lstFiltrosxPlan.find(groupFil => (groupFil.fi_OPCION_FILTRO === parseInt(option)))
                ContaFilter[2] = true
                if (doption !== undefined) {
                    flagOption = doption.fi_OPCION_FILTRO
                }
                console.log("option if getFilterPlansMulti***********", "option: " + parseInt(option), flagOption)
            }
            if (check) {
                // let dcheck = data.lstFiltrosxPlan.find(groupFil => (groupFil.fi_OPCION_FILTRO === parseInt(check)))
                // ContaFilter[4] = true
                // if (dcheck !== undefined) {
                //     flagCheck = dcheck.fi_OPCION_FILTRO
                // }
                // let getByChecked = dataFilterTypes.map((filt, index) => {
                //     if (filt.checked) {
                //         console.log("check if getFilterPlansMulti*********** check:", filt)
                //         return data.lstFiltrosxPlan.find(groupFil => (groupFil.fi_OPCION_FILTRO === filt.id))
                //     } else {
                //         return null;
                //     }
                // })
                let arraykeyCheck2 = []
                dataFilterTypes.forEach((filt, index) => {
                    if (filt.checked) {
                        
                        arraykeyCheck2.push(filt.id)
                        if(!ContaFilter.includes(filt.id)){
                            ContaFilter.push(filt.id);
                        }
                    }
                })
                // dataFilterTypesHead
                // .find(h => h.checked)?.lstHijos?.forEach((filt, index) => {
                //     let hijoSeleccionado = filt.lstHijos?.filter(h2 => h2.checked)
                //     if (filt.checked && !hijoSeleccionado.length) {
                //         if(!ContaFilterHijos.includes(filt.fi_OPCION_FILTRO)){
                //             ContaFilterHijos.push(filt.fi_OPCION_FILTRO);
                //         }
                //         arraykeyCheck2.push(filt.fi_OPCION_FILTRO)
                //     } else if(filt.checked && hijoSeleccionado.length) {
                //         // arraykeyCheck2.push(filt.fi_OPCION_FILTRO)
                //         // ContaFilterHijos.push(filt.fi_OPCION_FILTRO);
                //         if(!ContaFilterHijos.includes(filt.fi_OPCION_FILTRO)){
                //             ContaFilterHijos.push(filt.fi_OPCION_FILTRO);
                //         }
                //         let listaHijos = hijoSeleccionado.map(h3 => h3.fi_OPCION_FILTRO)
                //         // console.log("con hijoSeleccionado:::::::::::::::::::::::::", filt, listaHijos, ContaFilterHijos)
                //         Array.prototype.push.apply(arraykeyCheck2,listaHijos)
                //         // Array.prototype.push.apply(ContaFilterHijos,listaHijos)
                //         if (listaHijos?.length > 0){
                //             listaHijos.forEach(element => {
                //                 if(!ContaFilterHijos.includes(element)){
                //                     ContaFilterHijos.push(element)
                //                 }
                //             });
                //         }
                //     }
                // })

                let isExist = false
                let result = data.lstFiltrosxPlan.map(option => {
                    let isSameId = arraykeyCheck2.includes(option.fi_OPCION_FILTRO)
                    if (isSameId) isExist = true
                    return isExist
                })
                if (isExist || !arraykeyCheck2.length) {
                    flagCheck = 1
                }

                console.log("check if getFilterPlansMulti*********** CheckedsBox: isExist", isExist, result, arraykeyCheck2)
            }
            if ((flagInput > -1 || !input.length ) && ( flagComuna > -1 || flagOption !== -1 || flagCheck > -1)) {
                console.log("FLAGS-------------", flagInput, flagComuna, flagOption, flagCheck, data)
                return data
            } else {
                console.log("FLAGS ELSE-------------", flagInput, flagComuna, flagOption, flagCheck)
                return null
            }
        });

        let newDataFilterServOpc = dataServOpc.filter((data, index) => {
            let flagCheck = -1;
            if (check) {
                let arraykeyCheck2 = [], arraykeyCheck3 = []
                dataFilterTypesHead
                .find(h => h.checked)?.lstHijos?.forEach((filt, index) => {
                    let hijoSeleccionado = filt.lstHijos?.filter(h2 => h2.checked)
                    if (filt.checked && !hijoSeleccionado.length) {
                        arraykeyCheck2.push(filt.fi_OPCION_FILTRO)
                    } else if(filt.checked && hijoSeleccionado.length) {
                        let listaHijos = hijoSeleccionado.map(h3 => h3.fi_OPCION_FILTRO)
                        Array.prototype.push.apply(arraykeyCheck2,listaHijos)
                    }
                })

                if(filterServicesOptions.length && arraykeyCheck2.length){
                    let servOpIds = null
                    filterServicesOptions.forEach(item =>{
                        item.IdsFilters.forEach(d=>{
                            let idServiceOption = arraykeyCheck2.includes(d)
                            if(idServiceOption){
                                servOpIds = item.IdsFilters
                                servOpIds.forEach((sId, index) => {
                                    if(!arraykeyCheck2.includes(sId)){
                                        console.log("arraykeyCheck2:::::::::", sId)
                                        arraykeyCheck3.push(sId)
                                    }
                                })
                            }
                        })
                    })
                }

                let isExist = false
                let result = data.lstFiltrosxPlan.map(option => {
                    let isSameId = arraykeyCheck3.includes(option.fi_OPCION_FILTRO)
                    if (isSameId) isExist = true
                    return isExist
                })

                if (isExist) {
                    flagCheck = 1
                }
                console.log("check if getFilterPlansMulti*********** CheckedsBox: isExist", isExist, result, arraykeyCheck2)
            }
            if (flagCheck > -1) {
                console.log("FLAGS-------------", data)
                return data
            } else {
                console.log("FLAGS ELSE-------------", flagCheck)
                return null
            }
        });
        if (newDataFilterServOpc?.length){
            let arrayPlanData = newDataFilter
            newDataFilterServOpc.forEach((itemPlan, index)=>{
                let chechPlan = newDataFilter.filter(element => element.fi_PLAN === itemPlan.fi_PLAN)
                if (!chechPlan.length){
                    // console.log("newDataFilterServOpc::::::::::::: chechPlan", chechPlan, itemPlan)
                    Array.prototype.push.apply(arrayPlanData,[itemPlan]);
                }
            })
            newDataFilter = arrayPlanData;
            console.log("newDataFilterServOpc:::::::::::::", newDataFilter, newDataFilterServOpc)
        }

        if (!data.length){
            dataFilterTypesHead
                .find(h => h.checked)?.lstHijos?.forEach((filt, index) => {
                    let hijoSeleccionado = filt.lstHijos?.filter(h2 => h2.checked)
                    if (filt.checked && !hijoSeleccionado.length) {
                        if(!ContaFilterHijos.includes(filt.fi_OPCION_FILTRO)){
                            ContaFilterHijos.push(filt.fi_OPCION_FILTRO);
                        }
                        // arraykeyCheck2.push(filt.fi_OPCION_FILTRO)
                    } else if(filt.checked && hijoSeleccionado.length) {
                        if(!ContaFilterHijos.includes(filt.fi_OPCION_FILTRO)){
                            ContaFilterHijos.push(filt.fi_OPCION_FILTRO);
                        }
                        let listaHijos = hijoSeleccionado.map(h3 => h3.fi_OPCION_FILTRO)
                        
                        // Array.prototype.push.apply(arraykeyCheck2,listaHijos)
                        if (listaHijos?.length > 0){
                            listaHijos.forEach(element => {
                                if(!ContaFilterHijos.includes(element)){
                                    ContaFilterHijos.push(element)
                                }
                            });
                        }
                    }
                })
        }
        let dataNew = newDataFilter
        // console.log("FLAGS newDataFilter-------------", dataNew)
        let newDataFilterPrices = dataNew.filter((data, index) => {
            let flagPrices = -1
            if (price) {
                let dprice = ((data.fi_PRECIO_PLAN >= price.min) === true && (data.fi_PRECIO_PLAN <= price.max) === true);
                // ContaFilter[3] = true
                if (dprice) {
                    flagPrices = 1
                }
                console.log("function getFilterPlansMulti*********** price: ", price, dprice)
            }
            if (flagPrices > -1) {
                return data
            } else {
                return null
            }
        })
        let counter = 0
        ContaFilter.map((item, index) => (
            counter++
        ))
        ContaFilterHijos.map((item, index) => (
            counter++
        ))
        console.log(" ContaFilterHijos: ", counter, ContaFilter, ContaFilterHijos)
        setCounterFilters(counter)
        let list = newDataFilterPrices
        let list2 = newDataFilterPrices
        if(showRangPrice === false){
            list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)
        }else{
            list.sort((a, b) => (a.fi_PRECIO_PLAN > b.fi_PRECIO_PLAN) ? 1 : -1)
            let maxPrice = list.length > 0 ? list[list.length - 1]?.fi_PRECIO_PLAN : false
            if(maxPrice === 0){
                list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)
            }
            console.log("to search---------- por precio:")
        }
        if (OrdHigherLower !== null) {
            console.log("OrdHigherLower !null ", OrdHigherLower)
            if (OrdHigherLower === "1") {
                list2.sort((a, b) => (a.fi_PRECIO_PLAN > b.fi_PRECIO_PLAN) ? 1 : -1)
                console.log("OrdHigherLower >", OrdHigherLower)
            }
            if (OrdHigherLower === "2") {
                list2.sort((a, b) => (a.fi_PRECIO_PLAN < b.fi_PRECIO_PLAN) ? 1 : -1)
                console.log("OrdHigherLower <", OrdHigherLower)
            }
            if (OrdHigherLower === "3") {
                list2.sort((a, b) => 
                    a.fi_ORDEN_DESTACADO && b.fi_ORDEN_DESTACADO 
                        ? a.fi_ORDEN_DESTACADO < b.fi_ORDEN_DESTACADO ? -1 : 1 : 1)
                console.log("OrdHigherLower <", OrdHigherLower)
            }
            console.log("to OrdHigherLower----------:", list2)
            list = list2
        }

        let pageCountVal = newDataFilterPrices.length ? (Math.ceil(newDataFilterPrices.length / perPage)) : 1;
        setPageCount(pageCountVal)
        setdataCPlanes(list)
        // getMinMaxPrice()
        setOffset(0)
        console.log("to search---------- getFilterPlans:", newDataFilterPrices, newDataFilterPrices.length)
        // }
    }

    function onHandleClickSearch(e) {
        getFilterPlansMulti(rangePriceState, dataFilterTypesHead, filterComuna, optionFilter, inputSearch)
    }

    function routeChange(e) {
        console.log("routeChange__________***********", inputSearch, dataCPlanesBk,)
        let dataToItems = dataCPlanesBk.filter(f => keysPlanCompare.includes(f.fi_PLAN));
        let arrayItemes = { items: dataToItems }
        console.log("dataToItems::::::::::::::::::::", dataToItems, arrayItemes, keysPlanCompare.length);
        setRegresaPlanes(false)
        setDataToItems(arrayItemes)
        // history.push({ pathname: path, state: { data: { items: dataToItems }, plansToCompare: keysPlanCompare } });
    }

    function handlePageClick(d) {
        console.log("handlePageClick::::::::::::::::::::::::", d)
        setOffset(d.selected)
    }

    useEffect(() => {
        // getFilterTypesHead();
        getCPlanes();
        getRegiones();
        getFilterTypes();
        getFilterOptions();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {

        let preFilter = localStorage.getItem('preFilter') ? localStorage.getItem('preFilter').split(",") : '';
        console.log("preFilter::::::::::::::::::::::::", preFilter)
        if (preFilter.length && dataCPlanesBkHead.length && dataFilterTypesHead.length && preFilterRemove) {
            let FilterIdRadio = parseInt(preFilter[0].split(":")[1])
            let filterOptionRadio = preFilter[0].split(":")[0]

            let FilterId = parseInt(preFilter[1].split(":")[1])
            let FilterIdArray = preFilter[1].split(":")[1].indexOf("_") ? preFilter[1].split(":")[1] : [] 
            let filterOption = preFilter[1].split(":")[0]

            console.log("preFilter length::::::::::::::::::::::::", preFilter.length, preFilter, FilterIdRadio, filterOptionRadio, FilterId, filterOption)
            

            if (filterOption === "FilterId") {
                console.log("prefilter FilterId:", FilterIdArray.length, FilterIdArray)
                if (FilterIdArray.length){
                    FilterIdArray = FilterIdArray.split("_");
                    console.log("prefilter filterTypeArray:", FilterIdArray)
                    let auxFilterId = 0, el = {}, item={}
                    let auxHead = null, auxFirstChild = null
                    FilterIdArray.forEach(element => {
                        auxFilterId = parseInt(element)
                        console.log("prefilter filterTypeArray:", auxFilterId)
                        el = {target: { checked: true, name: auxFilterId}}
                        item = dataFilterTypes.filter(filt => filt.id === auxFilterId);
                        if(item.length){
                            console.log("prefilter filterType:", auxFilterId)
                            auxHead=auxFilterId;
                            getPlanesByCheckBoxChilds(el, item[0])
                        }
                        if (auxHead && !item.length){
                            let el = { target: { checked: true, name: auxFilterId}}
                            let itemfilterHead = dataFilterTypes.filter(filt => filt.id === auxHead);
                            let itemChild = itemfilterHead.length ? itemfilterHead[0].lstHijos.filter(filt => filt.fi_OPCION_FILTRO === auxFilterId) : [];
                            console.log("prefilter auxFilterId", auxFilterId, itemChild)
                            if(itemChild.length){
                                console.log("prefilter auxFilterId", auxFilterId)
                                auxFirstChild=auxFilterId
                                getPlanesByCheckBoxChilds(el, itemChild[0])
                            }
                            if(!itemChild.length && auxFirstChild){
                                let el = { target: { checked: true, name: auxFilterId}}
                                let itemfilterHead = dataFilterTypes.filter(filt => filt.id === auxHead);
                                let itemChild = itemfilterHead.length ? itemfilterHead[0].lstHijos.filter(filt => filt.fi_OPCION_FILTRO === auxFirstChild) : [];
                                let itemSecondChild = itemChild.length ? itemChild[0].lstHijos.filter(filt => filt.fi_OPCION_FILTRO === auxFilterId) : [];
                                console.log("prefilter itemSecondChild", auxFilterId, itemSecondChild)
                                if(itemChild.length){
                                    console.log("prefilter itemSecondChild", auxFilterId)
                                    getPlanesByCheckBoxChilds(el, itemSecondChild[0])
                                }
                            }
                        }
                    });

                }else{
                    let el = { target: { checked: true, name: FilterId}}
                    let item = dataFilterTypes.filter(filt => filt.id === FilterId);
                    console.log("prefilter filterType: Aqui1_", FilterId, item)
                    if(item.length){
                        console.log("prefilter filterType: Aqui", FilterId)
                        getPlanesByCheckBoxChilds(el, item[0])
                    }
                }
                if (preFilterRemove){
                    localStorage.removeItem('preFilter')
                    setPreFilterRemove(!preFilterRemove)
                }
                // let newArrayChecks = dataFilterTypes.map((filt, index) => {
                //     if (filt.id === FilterId) {
                //         filt.checked = true
                //     }
                //     return filt;
                // })
                // console.log("FilterId === ::::::::::::::::::::::::", FilterId, filterOption, newArrayChecks)
                // setOptionFilter('')
                // if (dataCPlanesBk?.length) {
                //     //console.log("dataCPlanesBk?.length............................... type 1", preFilterRemove, filterOption, dataCPlanesBk, dataCPlanes, newArrayChecks, dataFilterTypes)
                //     if (preFilterRemove) {
                //         //console.log("preFilter............................... type 1", filterOption, dataCPlanesBk, dataCPlanes, newArrayChecks, dataFilterTypes)
                //         // getFilterPlansMulti(rangePriceState, newArrayChecks, filterComuna, '', inputSearch)
                //         localStorage.removeItem('preFilter')
                //         setPreFilterRemove(!preFilterRemove)
                //         //console.log("preFilter............................... removeItem 1")
                //     }
                // }
            }
        }
        // eslint-disable-next-line
    }, [dataCPlanesBkHead])

    useEffect(()=>{
        let filterHead = parseInt(queryParams.get("filterHead"))
        let filterType = parseInt(queryParams.get("filterType"))
        let optionType = parseInt(queryParams.get("optionType"))
        if(filterHead !== null && dataCPlanesBkHead.length){
            let el = { target: { checked: true, name: filterHead }}
            let item = dataFilterTypesHead.filter(filt => filt.id === filterHead);
            if(item.length){
                console.log("prefilter filterHead:", filterHead)
                getPlanesByCheckBoxHead (el, item[0])
            }
        }

        if(filterType !== null && dataCPlanesBkHead.length){
            let el = { target: { checked: true, name: filterType}}
            let itemfilterHead = dataFilterTypesHead.filter(filt => filt.id === filterHead);
            let item = itemfilterHead.length ? itemfilterHead[0].lstHijos.filter(filt => filt.fi_OPCION_FILTRO === filterType) : [];
            if(item.length){
                console.log("prefilter filterType", filterType)
                getPlanesByCheckBoxChilds(el, item[0])
            }
        }
        if(optionType !== null && dataCPlanesBkHead.length){
            let el = { target: { checked: true, name: optionType}}
            let itemfilterHead = dataFilterTypesHead.filter(filt => filt.id === filterHead);
            let itemfilterType = itemfilterHead.length ? itemfilterHead[0].lstHijos.filter(filt => filt.fi_OPCION_FILTRO === filterType) : [];
            let item = itemfilterType.length ? itemfilterType[0].lstHijos.filter(filt => filt.fi_OPCION_FILTRO === optionType) : [];
            if(item.length){
                console.log("prefilter optionType", optionType)
                getPlanesByCheckBoxChilds(el, item[0])
            }
        }
        // eslint-disable-next-line
    },[dataCPlanesBkHead])
    // useEffect(()=>{
    //     let filterOption = parseInt(queryParams.get("filterOption"))

    //     if(filterOption !== null && dataFilterTypesChilds.length && preFilterOption){
    //         let el = { target: { checked: true, name: filterOption}}
    //         let item = dataFilterTypesChilds.filter(filt => filt.fi_OPCION_FILTRO === filterOption);
    //         setPreFilterOption(!preFilterOption)
    //         if(item.length){
    //             console.log("prefilter filterOption", filterOption)
    //             getPlanesByCheckBoxChilds(el, item[0])
    //         }
    //     }
    //     // eslint-disable-next-line
    // },[dataFilterTypesChilds])

    function calculateInitElementShow() {
        const result = offset * perPage
        return result
    }

    function calculateFnElementShow() {
        return calculateInitElementShow() + perPage
    }

    function getCalculatePageCount() {

        let pageCountVal = dataCPlanes?.length ? (Math.ceil(dataCPlanes.length / perPage)) : pageCount;
        return pageCountVal
    }

    function onChangeOptions(e) {
        let OrdHigherLower = e.target.value
        setOptiondHigherLower(OrdHigherLower)
        getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, optionFilter, inputSearch, OrdHigherLower)
        console.log("onChangeOptions:", e.target.value, e)
    }


    const PlayPLanData = dataCPlanes.length ? dataCPlanes.slice(calculateInitElementShow(), calculateFnElementShow()).map((item, index) => (
        <div key={uuid()} className="c23Item" data-idplan={item.fi_PLAN}>
            <General2PlanCardMol
                key={uuid()}
                title={item.fc_TEXTO_CAJA.trimEnd()}
                titlestyle={item.fc_COLOR_CAJA ? item.fc_COLOR_CAJA.toLowerCase() : null}
                name={item.fc_NOMBRE.trimEnd()}
                changeCompare={handleChangeCompare}
                fi_PLAN={item.fi_PLAN}
                fi_ID_TELEFONIA={item.fi_ID_TELEFONIA}
                fi_ID_TELEVISION={item.fi_ID_TELEVISION}
                fi_ID_INTERNET={item.fi_ID_INTERNET}
                fi_CATEGORIA={item.fi_CATEGORIA}
                fc_TIPO_DISPONIBILIDAD={item.fc_TIPO_DISPONIBILIDAD}
                fc_TEXTO_CAJA={item.fc_TEXTO_CAJA}
                fc_COLOR_CAJA={item.fc_COLOR_CAJA}
                fc_NOMBRE={item.fc_NOMBRE}
                fc_DESCRIPCION={item.fc_DESCRIPCION}
                fi_NUMERO_CARACTERISTICAS_MOSTRAR={item.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
                fc_TITULO_CARACTERISTICAS_AGRUPADAS={item.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
                fi_PRECIO_PLAN={item.fi_PRECIO_PLAN > 0 ? <NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={Number.isInteger(item.fi_PRECIO_PLAN) ? item.fi_PRECIO_PLAN : item.fi_PRECIO_PLAN.toFixed(2)} />: null}
                fi_PRECIO_TELEFONIA_ENPS={item.fi_PRECIO_TELEFONIA_ENPS}
                fi_PRECIO_TELEVISION_ESPN={item.fi_PRECIO_TELEVISION_ESPN}
                fi_PRECIO_INTERNET_ESPS={item.fi_PRECIO_INTERNET_ESPS}
                fc_COLOR_PRECIO={item.fc_COLOR_PRECIO}
                fc_ETIQUETA_PRECIO_TACHADO={item.fc_ETIQUETA_PRECIO_TACHADO}
                fc_PRECIO_TACHADO={<NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={item.fc_PRECIO_TACHADO.includes(".") ? item.fc_PRECIO_TACHADO : item.fc_PRECIO_TACHADO } />}
                Discount={item?.fc_PRECIO_TACHADO > 0 && parseInt(item.fc_PRECIO_TACHADO) !== parseInt(item.fi_PRECIO_PLAN) ? <NumberFormat displayType={'text'} value={(100 - (item.fi_PRECIO_PLAN * 100) / item.fc_PRECIO_TACHADO).toFixed(0)} /> : null}
                fc_NOTA_DEBAJO_PRECIO={item.fc_NOTA_DEBAJO_PRECIO}
                fc_TEXTO_DETALLE={item.fc_TEXTO_DETALLE}
                fc_URL_DETALLE={item.fc_URL_DETALLE}
                fc_TARGET_DETALLE={item.fc_TARGET_DETALLE}
                fi_BAN_DETALLE={item.fi_BAN_DETALLE}
                fc_OPCION_CONTRATACION={item.fc_OPCION_CONTRATACION}
                fc_TEXTO_CONTRATAR={item.fc_TEXTO_CONTRATAR}
                fc_URL_CONTRATAR={item.fc_URL_CONTRATAR}
                fc_TARGET_CONTRATAR={item.fc_TARGET_CONTRATAR}
                fi_BAN_CONTRATAR={item.fi_BAN_CONTRATAR}
                fi_ORDEN={item.fi_ORDEN}
                fi_ACTIVO={item.fi_ACTIVO}
                fi_ID_DASHBOARD={item.fi_ID_DASHBOARD}
                fi_BAN_ENPN={item.fi_BAN_ENPN}
                fi_BAN_ENPS={item.fi_BAN_ENPS}
                fi_BAN_ESPN={item.fi_BAN_ESPN}
                fi_BAN_ESPS={item.fi_BAN_ESPS}
                fc_ETIQUETA_PROMOCION_ATP={item.fc_ETIQUETA_PROMOCION_ATP}
                fi_PRECIO_AHORRO={item.fi_PRECIO_AHORRO}
                fc_ETIQUETA_PERIODO={item.fc_ETIQUETA_PERIODO}
                fc_TITULO_PROMO={item.fc_TITULO_PROMO}
                Caracteristicas={item.caracteristicas}
                caracteristicasPromocion={item.caracteristicasPromocion}
                Acordeon={item.acordeon}
                lstPlanContratacionxPlan={item.lstPlanContratacionxPlan}
                keysPlanCompare={keysPlanCompare}
                fi_INCLUIR_SECCION={item.fi_INCLUIR_SECCION}
                fc_ETIQUETA_ROJA={item.fc_ETIQUETA_ROJA}
                fc_TITULO_SECCION={item.fc_TITULO_SECCION}
                fc_DESCRIPCION_SECCION={item.fc_DESCRIPCION_SECCION}
                fc_TEXTO_BOTON={item.fc_TEXTO_BOTON}
                fc_TARGET_BOTON={item.fc_TARGET_BOTON}
                fc_URL_BOTON={item.fc_URL_BOTON}
                fc_DESCRIPCION_OFERTA={item.fc_DESCRIPCION_OFERTA}
                fc_PLAN_ICONO={item.fc_PLAN_ICONO}
                fi_SERVICIO={item.fi_SERVICIO}
                fc_DETALLE_PLAN={item?.fc_DETALLE_PLAN ? item.fc_DETALLE_PLAN : ""}
                fc_FAMILIA={item.fc_FAMILIA}
                dataChannelsBk={dataChannelsBk}
                dataCategoriasBk={dataCategoriasBk}
            />
           
        </div>
    )) : null

    // let perPage = 6;
    const onSubmitFilter = data => {
        console.log('Submit filters:', data);
    }

    let rangePrice = {
        min: rangePriceState.min,
        max: rangePriceState.max,
    }

    const optionsRegiones = dataRegiones.length ? dataRegiones.map((item, index) => (
        <option key={uuid()} value={item.value}>{item.label}</option>
    )) : null

    // const optionsFilterOptions = dataFilterOptions.length ? dataFilterOptions.map((item, index) => (
    //     <option key={uuid()} value={item.value}>{item.label}</option>
    // )) : null

    // console.log('dataFilterTypes', dataFilterTypes, pageCount);
    const displayCompare = localStorage.getItem('id_status')  === "none"  ? "none" : "";
    const symbolPrice = "RD$";
    return (

        dataToItems?.items && !regresaPlanes
            ?
            <C25PeopleOrg
                key={uuid()}
                dataCompare={dataToItems}
                resetHandleClick={resetHandleClick}
                removeItemHandleClick={removeItemHandleClick}
                setRegresaPlanes={setRegresaPlanes}
                symbolPrice={symbolPrice}
            />
            :
            <>
            {
                dataCPlanesBkHead?.length && rangePriceState?.max
                ?
                <section className='c23Wrap'>
                    <div className="container">
                        <div className="c23">
                            <div className="c23Fil">
                                <ServiceFilter
                                    onSubmit={onSubmitFilter}
                                    rangePrice={rangePrice}
                                    showFilter={showFilter}
                                    setShowFilter={setShowFilter}
                                    // dataRegiones={dataRegiones}
                                    optionsRegiones={optionsRegiones}
                                    dataFilterTypes={dataFilterTypes}
                                    dataFilterTypesChilds={dataFilterTypesChilds}
                                    dataFilterTypesHead={dataFilterTypesHead}
                                    handleChangeFilterPrice={handleChangeFilterPrice}
                                    getPlanesByComuna={getPlanesByComuna}
                                    getPlanesByCheckBox={getPlanesByCheckBox}
                                    getPlanesByCheckBoxChilds={getPlanesByCheckBoxChilds}
                                    getPlanesByCheckBoxHead={getPlanesByCheckBoxHead}
                                    // keysTypeCompare={keysTypeCompare}
                                    counterFilters={counterFilters + counterFiltersHead}
                                    clearFilters={clearFilters}
                                    showRangPrice={showRangPrice}
                                />
                            </div>
                            <div className="c23Cont">
                                <Title
                                    tag={TitleTag.H2}
                                    style={TitleStyle.H2}
                                    className='c23HeaderTit'
                                >
                                    {
                                        localStorage.getItem('titulo_seccion') ? localStorage.getItem('titulo_seccion') : Parser("&nbsp;")
                                    }
                                </Title>
                                <div className="c23Bar">
                                    <div className="c23BarDrop">
                                        <span className="select">
                                            <select value={optiondHigherLower} onChange={(e) => { onChangeOptions(e) }}>
                                                <option value='' disabled>Ordenar por:</option>
                                                <option value='2'>Precio: Mayor a menor</option>
                                                <option value='1'>Precio: Menor a mayor</option>
                                                <option value='3'>Destacados</option>
                                            </select>
                                        </span>

                                    </div>
                                    <div className="c23BarSearch">
                                        <label className='inputSearch'>
                                            <input className='' type={'search'} placeholder="Buscar" aria-label='Buscar' autoComplete='off' value={inputSearch} onChange={e => onChangeInputSearch(e)}></input>
                                        </label>
                                        {/* <SearchField
                                            onChange={e => onChangeInputSearch(e)}
                                            value={inputSearch}
                                        /> */}

                                    </div>
                                    <div className="c23BarAct">
                                        <Button
                                            onClick={e => onHandleClickSearch(e)}
                                        >
                                            Buscar
                                        </Button>
                                    </div>
                                </div>

                                <div className="c23Header">
                                    {/* <div className='c23HeaderFilter' onClick={() => { setShowFilter(!showFilter) }}>

                                        <p>Filtros <i className='ico-sliders'></i></p>

                                    </div> */}
                                    <div className="c23HeaderComp">
                                        {
                                            displayCompare === ""
                                            ?
                                            <>
                                            <div className="c23HeaderCompRad">
                                                <InputSelect
                                                    type={InputSelectType.RADIO}
                                                    text=''
                                                    name='comparee[0]'
                                                    className=''
                                                    disabled={true}
                                                    checked={keysPlanCompare[0] ? true : false}
                                                />
                                                <InputSelect
                                                    type={InputSelectType.RADIO}
                                                    text=''
                                                    name='comparee[1]'
                                                    className=''
                                                    disabled={true}
                                                    checked={keysPlanCompare[1] ? true : false}
                                                />
                                                <InputSelect
                                                    type={InputSelectType.RADIO}
                                                    text=''
                                                    name='comparee[2]'
                                                    className=''
                                                    disabled={true}
                                                    checked={keysPlanCompare[2] ? true : false}
                                                />
                                                <InputSelect
                                                    type={InputSelectType.RADIO}
                                                    text=''
                                                    name='comparee[3]'
                                                    className=''
                                                    disabled={true}
                                                    checked={keysPlanCompare[3] ? true : false}
                                                />
                                                <InputSelect
                                                    type={InputSelectType.RADIO}
                                                    text=''
                                                    name='comparee[4]'
                                                    className=''
                                                    disabled={true}
                                                    checked={keysPlanCompare[4] ? true : false}
                                                />
                                            </div>
                                            <div className="c23HeaderCompBtn">

                                                <Button
                                                    category={ButtonCategory.TRANS_GRIS}
                                                    onClick={keysPlanCompare.length >= 2 ? e => routeChange(e) : null}
                                                >
                                                    Comparar servicios
                                                </Button>
                                            </div>
                                            </>
                                            : null
                                        }
                                    </div>
                                </div>

                                <div className="c23Items">
                                    {
                                        PlayPLanData
                                    }

                                </div>
                                <div className="c23Pag">
                                    {
                                        dataCPlanes.length
                                            ?
                                            <PaginationMol
                                                pageCount={getCalculatePageCount()}
                                                onPageChange={handlePageClick}
                                                initialPage={0}
                                                forcePage={offset}
                                            />
                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                :
                <div className="loader-container">
                    <div className="spinner"></div>
                </div>
            }
            </>
    )
}

export default C23PersonasOrg